/**
 * Overlay-boundary marker. Panes that overlay panels must mount into to stack
 * correctly (dialog content panes, side panels) carry this attribute as a plain
 * static attribute. Overlay triggers resolve the nearest marked ancestor at
 * open time and fall back to `body` on plain pages, so in-dialog dropdowns,
 * menus and popovers need no per-site container wiring. An explicit container
 * input always overrides the resolution.
 */
export const SUI_BOUNDARY_ATTR = 'data-sui-popover-boundary';

export const SUI_BOUNDARY_SELECTOR = `[${SUI_BOUNDARY_ATTR}]`;

/** Nearest marked boundary pane above `from`, else `'body'`. */
export function resolveSuiBoundary(from: HTMLElement): HTMLElement | 'body' {
  return from.closest<HTMLElement>(SUI_BOUNDARY_SELECTOR) ?? 'body';
}
